/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Section_Project_ContextInputs */

const en_ad_section_project_context = /** @type {(inputs: Ad_Section_Project_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Context`)
};

const fr_ad_section_project_context = /** @type {(inputs: Ad_Section_Project_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contexte du projet`)
};

const de_ad_section_project_context = /** @type {(inputs: Ad_Section_Project_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektkontext`)
};

const it_ad_section_project_context = /** @type {(inputs: Ad_Section_Project_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contesto del progetto`)
};

const ru_ad_section_project_context = /** @type {(inputs: Ad_Section_Project_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контекст проекта`)
};

const es_ad_section_project_context = /** @type {(inputs: Ad_Section_Project_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contexto del proyecto`)
};

const zh_cn2_ad_section_project_context = /** @type {(inputs: Ad_Section_Project_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目背景`)
};

const ja_ad_section_project_context = /** @type {(inputs: Ad_Section_Project_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトの背景`)
};

const hi_ad_section_project_context = /** @type {(inputs: Ad_Section_Project_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परियोजना संदर्भ`)
};

const pt_pt2_ad_section_project_context = /** @type {(inputs: Ad_Section_Project_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contexto do Projeto`)
};

/**
* | output |
* | --- |
* | "Project Context" |
*
* @param {Ad_Section_Project_ContextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_section_project_context = /** @type {((inputs?: Ad_Section_Project_ContextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Section_Project_ContextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_section_project_context(inputs)
	if (locale === "de") return de_ad_section_project_context(inputs)
	if (locale === "it") return it_ad_section_project_context(inputs)
	if (locale === "ru") return ru_ad_section_project_context(inputs)
	if (locale === "es") return es_ad_section_project_context(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_section_project_context(inputs)
	if (locale === "ja") return ja_ad_section_project_context(inputs)
	if (locale === "hi") return hi_ad_section_project_context(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_section_project_context(inputs)
	return en_ad_section_project_context(inputs)
});